export const pages = [
    { name: 'Collaborators', link: '/form/collaborators', translationKey: 'pages.collaborators' },
    { name: 'General', link: '/form/general', translationKey: 'pages.general' },    
    { name: 'Schedule', link: '/form/schedule', translationKey: 'pages.schedule' },
    { name: 'Labor Legislation', link: '/form/legislation', translationKey: 'pages.legislation' },
    { name: 'Vacations', link: '/form/absences', translationKey: 'pages.vacations' },
    { name: 'Shift Restrictions', link: '/form/availability', translationKey: 'pages.shiftRestrictions' },
    { name: 'Transitions', link: '/form/transitions', translationKey: 'pages.transitions' },
    { name: 'Staff Requirements', link: '/form/staff', translationKey: 'pages.staffRequirements' },
    { name: 'Staff Distribution', link: '/form/distribution', translationKey: 'pages.staffDistribution' },
    { name: 'Shift Sequence', link: '/form/sseq', translationKey: 'pages.shiftSequence' },
    { name: 'Weekly Sum', link: '/form/wsum', translationKey: 'pages.weeklySum' },
    { name: 'Generate Schedule', link: '/form/generate', translationKey: 'pages.generateSchedule' },
];